import { DiamondLG } from './DiamondLG';
import { DiamondMD } from './DiamondMD';
import { DiamondSM } from './DiamondSM';
import { DiamondXL } from './DiamondXL';

export default {
    sm: DiamondSM,
    md: DiamondMD,
    lg: DiamondLG,
    xl: DiamondXL,
};
